import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import luxuryLifestyle from "../../components/Main/Landing/images/luxury_lifestyle.png";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    padding: '60px 5% 0',
    backgroundColor: '#0d0d0d',
    marginBottom: '60px',
    maxHeight: 450,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      padding: '28px 20px 40px',
      maxHeight: 'none',
      marginBottom: '34px',
    }
  },
  heroInner: {
    maxWidth: 1314,
    margin: '0 auto',
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '20px',
    }
  },
  heroTextContainer: {
    flex: 1,
    maxWidth: '700px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingBottom: '80px',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
      alignItems: 'center',
      textAlign: 'center',
    }
  },
  heroTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '64px',
    fontWeight: 400,
    marginBottom: '20px',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      whiteSpace: 'normal',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '44px',
      lineHeight: '100%',
      width: "90%"
    }
  },
  heroSubtitle: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '18px',
    color: 'rgba(255, 255, 255, 0.7)',
    lineHeight: '27px',
    marginBottom: '24px',
    fontWeight: 200,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '24px',
    }
  },
  breadcrumbs: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '16px',
    gap: '8px',
    display: "flex",
    alignItems: "center",
    fontWeight: 400,
    color: 'rgba(255, 255, 255, 0.7)',
    '& span': {
      color: '#FE5A97',
      fontWeight: 500,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '2px',
      fontSize: '16px',
    }
  },
  heroImageContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    }
  },
  heroImage: {
    maxWidth: '100%',
    height: '440px',
    objectFit: 'contain',
    display: 'block',
    borderRadius: '16px',
  },
}));

export const LifestyleHeroSection = () => {
  const classes = useStyles();
  return (
    <Box className={classes.heroSection}>
      <Box className={classes.heroInner}>
        <Box className={classes.heroTextContainer}>
          <Typography className={classes.heroTitle}>
            Experience the Luxury Lifestyle
          </Typography>
          <Typography className={classes.heroSubtitle}>
            Explore exclusive content featuring luxury travel, fashion, fine dining, and unforgettable experiences shared by premium creators.
          </Typography>
          <Typography className={classes.breadcrumbs}>
            Home
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L5 5L1 9" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>Lifestyle &amp; Luxury Travel</span>
          </Typography>
        </Box>
        <Box className={classes.heroImageContainer}>
          <img
            src={luxuryLifestyle}
            alt="Experience the Luxury Lifestyle"
            className={classes.heroImage}
          />
        </Box>
      </Box>
    </Box>
  );
};
